import { playerPathwayImage } from '@/assets/images';
import { Image, ImageProps } from '@/components/ui';
import { useScaling } from '@/hooks';

export function PlayerPathwayImage({ ...props }: Omit<ImageProps, 'source'>) {
  const { scale } = useScaling();
  return (
    <Image
      source={playerPathwayImage}
      width={scale(240)}
      resizeMode="contain"
      height={scale(109)}
      {...props}
    />
  );
}
